import React from 'react';
import styled from 'styled-components';

import { colours, layout } from '../theme';

const DayCtn = styled.div`
  display: flex;
  align-items: center;
  width: ${layout.leftMarginWidth};
`;

const Title = styled.h3`
  margin-right: 12px;
  font-family: 'Work Sans', sans-serif;
  /* font-style: italic; */
  color: ${colours.darkGrey};
  text-transform: uppercase;
`;

const Dash = styled.div`
  height: 1px;
  width: 24px;
  background: ${colours.darkGrey};
`;

function DayNumber(props) {
  return (
    <DayCtn>
      <Title>{props.children}</Title>
      <Dash />
    </DayCtn>
  );
}

export default DayNumber;
